<h1>
  {{ (!summaryMode ? 'rspAssessmentHeading' : 'rspReviewHeading') | translate }}
  @if (insuredPersonFullName) {
    <br />
    {{ 'rspInsuredPersonText' | translate: { insuredPersonName: insuredPersonFullName } }}
  }
</h1>
<form class="mx-1 rsp-assessment" [class.review-form]="summaryMode">
  @if (activeAssessmentId) {
    <cep-web-questionnaire
      #questionnaireComponent
      [assessmentId]="activeAssessmentId"
      [config]="questionnaireConfig"
      [summaryMode]="summaryMode"
      [language]="language"
      [translations]="translations"
      [paginationMode]="paginationMode"
      [activePageId]="activePageId"
      [arsp-containerpplication]="applicationData"
      [rtl]="isRtl"
      [authorizationHandler]="renewToken"
      (activePageIdChange)="activePageId = $event.detail"
      (notification)="onNotification($event.detail)"
      (initializedChange)="onQuestionnaireInit()"
      (assessmentFinished)="onAssessmentFinished()"
      (applicationChange)="applicationData = $event.detail"
      (summaryModeChange)="onSummaryModeChange($event.detail)"
    >
      <div slot="before">
        <cep-web-blocked-pagination-alert></cep-web-blocked-pagination-alert>
        @if (showPaginationBreadcrumb) {
          <cep-web-breadcrumb-pagination></cep-web-breadcrumb-pagination>
        }
        @if (showFullPagePaginationBar) {
          <cep-web-full-page-pagination></cep-web-full-page-pagination>
        }
      </div>
      <div slot="after" class="d-flex justify-content-between overflow-x-auto rsp-assessment-bottom-navigation flex-column">
        <cep-web-question-reminder [offset]="54"></cep-web-question-reminder>
        <div>
          <cep-web-questionnaire-legend></cep-web-questionnaire-legend>
          <cep-web-prev-next-pagination></cep-web-prev-next-pagination>
        </div>
        <div class="d-flex justify-content-between container-fluid p-0">
          <cep-web-summary-button [class.ms-auto]="!summaryMode" [shouldBeDisabled]="cepButtonDisabledOption"></cep-web-summary-button>
          @if (summaryMode) {
            <cep-web-submit-button [shouldBeDisabled]="cepButtonDisabledOption"></cep-web-submit-button>
          }
        </div>
      </div>
    </cep-web-questionnaire>
  }
</form>
